import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/promotional-code-new",
    class: "btn btn-primary m-2",
    target: "_blank"
  }, "Add new"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/bulk-promotional-code",
    class: "btn btn-primary m-2",
    target: "_blank"
  }, "Bulk create")
], -1)
const _hoisted_2 = { ref: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, null, 512)
  ], 64))
}